import { call, put, select, takeLatest } from '@redux-saga/core/effects';
import globalInfoApi from '../../api/globalInfoApi';
import { globalInfoActions } from '../creators';
import { makeGetCountriesSelector } from '../selectors/globalInfo';
import { syncInfoActions } from '../creators/syncInfo';
import { SyncInfo } from 'modules/app/types';

function* globalInfoSaga() {
  yield takeLatest(globalInfoActions.getCountries, handleGetCountries);
  yield takeLatest(syncInfoActions.getSyncInfo, handleGetSyncInfo);
}

function* handleGetCountries() {
  const countries = yield select(makeGetCountriesSelector());

  if (countries.length > 0) {
    return;
  }

  yield put(globalInfoActions.getCountriesRequest.request());

  try {
    const payload = yield call(globalInfoApi.getCountries);
    yield put(globalInfoActions.getCountriesRequest.success(payload));
  } catch (e) {
    yield put(globalInfoActions.getCountriesRequest.failure(e.response));
  }
}

function* handleGetSyncInfo() {
  const { request, success, failure } = syncInfoActions.getSyncInfoRequest;
  yield put(request());
  try {
    const payload: SyncInfo = yield call(globalInfoApi.getSyncInfo);
    yield put(success(payload));
  } catch (e) {
    yield put(failure(e.response));
  }
}

export default globalInfoSaga;
